import { render, staticRenderFns } from "./bmi_sub_merchant.vue?vue&type=template&id=722787ee&scoped=true&"
import script from "./bmi_sub_merchant.vue?vue&type=script&lang=js&"
export * from "./bmi_sub_merchant.vue?vue&type=script&lang=js&"
import style0 from "./bmi_sub_merchant.vue?vue&type=style&index=0&id=722787ee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "722787ee",
  null
  
)

export default component.exports